<template>
  <div>
    <mf-tooltip v-if="Boolean(lastUpdatedFormated)" bottom>
      <template #activator="{ on }">
        <span v-on="on">
          <p :class="['caption', 'ultima-atualizacao', isFranchise ? 'clickable' : '']" @click="openLastUpdatedModal">
            <mf-icon small fill :color="lastUpdatedFormated.color">fiber_manual_record</mf-icon>
            <span :class="[isFranchise ? 'link' : '']"
              >Última atualização: {{ atualizacaoFormatada }}
              <span v-if="lastUpdate.update_status === 'UPDATING'">(Atualizando)</span>
              <span v-else>({{ fromNow }})</span>
            </span>
            <span class="help-icon" v-on="on">
              <mf-icon small>info</mf-icon>
            </span>
          </p>
        </span>
      </template>
      <span>{{ lastUpdatedFormated.text }}</span>
    </mf-tooltip>
    <last-updated-modal v-model="isLastUpdatedModalOpen" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { DateTime } from 'luxon'

export default {
  components: {
    LastUpdatedModal: () => import('@/components/last-updated/LastUpdatedModal.vue'),
  },
  data: () => ({
    lastUpdatedFormated: null,
    isLastUpdatedModalOpen: false,
  }),
  computed: {
    ...mapState({
      lastUpdate: (state) => state.lastUpdate,
    }),
    isFranchise() {
      return this.$getLoggedUser().is_franchise
    },
    atualizacaoFormatada() {
      return DateTime.fromFormat(this.lastUpdate.last_updated.toString(), 'yyyyMMdd').toFormat('dd/MM/yyyy')
    },
    fromNow() {
      const now = DateTime.now()
      return Math.floor(now.diff(DateTime.fromFormat(this.lastUpdate.last_updated.toString(), 'yyyyMMdd'), ['days']).days) + ' dias'
    },
  },

  beforeMount() {
    this.getData()
  },

  methods: {
    async getData() {
      await this.$store.dispatch('getStates', ['getLastUpdate']).then(() => {
        this.lastUpdatedFormated = this.getFormatedStatus()
      })
    },

    openLastUpdatedModal() {
      if (this.isFranchise) {
        this.isLastUpdatedModalOpen = true
      }
    },

    getFormatedStatus() {
      switch (this.lastUpdate.update_status) {
        case 'UPDATED':
          return {
            color: '#03e36a',
            status: 'Atualizado',
            text: 'Plataforma com os dados mais atuais disponibilizados pelo cliente.',
          }
        case 'UPDATING':
          return {
            color: '#2c67e6',
            status: 'Atualizando',
            text: 'Atualizando, por favor aguarde alguns minutos.',
          }
        case 'SCHEDULED':
          return {
            color: '#ffe200',
            status: 'Agendado',
            text: 'A atualização ocorrerá no horário agendado.',
          }
        case 'OUTDATED':
          return {
            color: '#F54336',
            status: 'Desatualizado',
            text: 'Falha na coleta de dados. Iremos verificar.',
          }
        default:
          return {
            color: '',
            status: '',
            text: '',
          }
      }
    },
  },
}
</script>
<style lang="scss">
.ultima-atualizacao {
  margin: 0;
  color: rgba(0, 0, 0, 0.38);
  .help-icon {
    line-height: 0.1;
    margin-left: 4px;
  }
}
.clickable {
  cursor: pointer;
}
</style>
